// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonSwitch_root__qxu8s","switchContainer":"ButtonSwitch_switchContainer__Y_ClH","option":"ButtonSwitch_option__VSXdr","optionActive":"ButtonSwitch_optionActive__yELAr"};